import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[gtdRemoveWhitespace]'
})
export class RemoveWhitespaceDirective {
  constructor(private ref: ElementRef, private ngControl: NgControl) {}
  @HostListener('input', ['$event.target'])
  removeWhitespace(input) {
    const newValue = input.value.replace(/\s+/g, '');
    this.ngControl.control.setValue(newValue, { emitEvent: true });
  }
}
